import { render, staticRenderFns } from "./MenuClientes.vue?vue&type=template&id=12f2db88"
import script from "./MenuClientes.vue?vue&type=script&lang=js"
export * from "./MenuClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports